// extracted by mini-css-extract-plugin
module.exports = {"main":"#FC1616","menuBg":"#ffffff","menuActive":"linear-gradient(270deg, #FC1616 0%, #FF953E 100%)","menuOnLeveltext":"#fff","menuText":"#73758F","menuTitleText":"#33343D","menuOnLevelBg":"#2F3442","menuOnLevelHover":"#242833","sideBarWidth":"220px","topBarHeight":"56px"};
    if(module.hot) {
      // 1749265863872
      var cssReload = require("/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  